import axios from 'axios';

const API_BASE_URL = `https://www.dooocs.com/api`;


// 创建带全局配置的axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

// 标签请求接口
interface TagRequest {
  targetId: string | number;
  name: string;
  targetType?: string;
}

// 标签响应接口
interface TagResponse {
  id: number;
  name: string;
  cnt: number;
  targetType: string;
  targetId: string;
  createdAt: string;
  updatedAt: string;
}


// 请求拦截器（可选）
apiClient.interceptors.request.use(config => {
  console.log('Requesting:', config.url);
  return config;
});

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    console.log('Response:', response.status, response.data);
    return response;
  },
  error => {
    console.error('API Error:', error.message);
    return Promise.reject(error);
  }
);

const tagApi = {
  getRankingListTags: (rankingId: string | number) => 
    apiClient.get<TagResponse[]>(`/tags/ranking-list/${rankingId}`),

  getRankingItemTags: (itemId: string | number) => 
    apiClient.get<TagResponse[]>(`/tags/ranking-item/${itemId}`),

  addRankingListTag: (rankingId: string | number, tagName: string) => 
    apiClient.post('/tags/ranking-list', { 
      targetId: rankingId, 
      name: tagName 
    }),

  addRankingItemTag: (itemId: string | number, tagName: string) => 
    apiClient.post('/tags/ranking-item', {
      targetId: itemId,
      name: tagName
    }),

  removeTag: (targetType: string, targetId: string | number, tagName: string) => 
    apiClient.post('/tags/remove', {
      targetType, targetId, name: tagName
    })
};

export default tagApi;
 